export const SET_ADDRESSES = 'setAddresses'
export const APPEND_ADDRESSES = 'appendAddresses'
export const SET_ADDRESSES_LOADING = 'setAddressesLoading'
